module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAmCAMAAACf4xmcAAAAV1BMVEUAAABnfqxnfqxnfqxnfqxnfqxnfqxnfqxnfqxnfqxnfqxnfqxnfqxnfqxnfqxnfqxnfqxnfqxnfqxnfqxnfqxnfqxnfqxnfqxnfqxnfqxnfqxnfqxnfqzxxpFoAAAAHHRSTlMA5dwJ6uL0P5F2LhjXl4uG7dHNu044DqhtWjYWtf753wAAAJBJREFUOMvt0kkOwjAQBdHvtGfHdmYm3/+cJAskaBDxNlJq/ZaFs+NFrpHilWxy+M2u5TO7YG2aGBsYaz1AWXeMKcaUAUVdJGMNY8Ig6VXvsAvduk3/Z8qHoeyzBKcrmEUuFUzejapgZQy2hon5MVYwZTC336xlrPeA6YtmLDHmCICPlrEQxftIbsEWEc4O1xPDgR2nMXsSTQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index_ico6.png
// module id = FiHh
// module chunks = 1